import assign from 'lodash/assign';
import constants from '../constants';
import sharedConfig from '../../sharedConfig';

const initState = () => ({
  hostname: null,
  brand: sharedConfig.defaultBrand,
  userAgent: '',
  isMobile: false,

  // DESTRUCTIVE: should redirect the app and end this req.
  // this should never be populated on the client!!
  serverSideRedirectUrl: '',
  serverSideRedirectStatusCode: undefined,
});

const app = (state = initState(), action = {}) => {
  const { type, payload } = action;

  if (type === constants.UPDATE_APP) {
    return assign({}, state, payload);
  } else {
    return state;
  }
};

export default app;
